export default function Footer() {
    return (<footer>
    	<span>Carefully crafted by Dyenamite</span>
    	<a href="https://github.com/lucadye/quickr">View the source on github</a>
    </footer>);
}
